import { de_StartSimulationCommand, se_StartSimulationCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
export { $Command };
export class StartSimulationCommand extends $Command.classBuilder()
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
    ];
})
    .s("SimulationService", "StartSimulation", {})
    .n("SimulationServiceClient", "StartSimulationCommand")
    .f(void 0, void 0)
    .ser(se_StartSimulationCommand)
    .de(de_StartSimulationCommand)
    .build() {
}
